import type { ReactNode } from "react";

import InfoPopover from "./InfoPopover";

type Props = {
  label: string;
  children: ReactNode;
  help?: ReactNode;
  className?: string;
};

export default function FilterField({
  label,
  children,
  help,
  className,
}: Props) {
  return (
    <div
      role="group"
      aria-label={label}
      className={["relative min-w-0", className ?? ""].join(" ").trim()}
    >
      <div className="mb-1 flex h-5 items-center gap-1.5 text-xs font-medium text-slate-600">
        <span>{label}</span>
        {help ? (
          <InfoPopover
            ariaLabel={`${label} erklären`}
            triggerClassName="inline-flex h-5 w-5 items-center justify-center rounded-full border border-slate-200 bg-white text-[10px] font-semibold text-slate-500 shadow-sm hover:border-emerald-200 hover:text-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500/30"
            popoverClassName="absolute right-0 top-full z-40 mt-1.5 w-[min(20rem,calc(100vw-3rem))]"
          >
            <div className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-normal leading-relaxed text-slate-700 shadow-lg ring-1 ring-slate-100">
              {help}
            </div>
          </InfoPopover>
        ) : null}
      </div>
      {children}
    </div>
  );
}
